import type { CommandSource } from '@sp-saljapro/command-menu';

import { analyticsEvents, trackAnalyticsEvent } from './analytics.utils';

export const trackCommand = (commandId: string, source?: CommandSource) => {
    trackAnalyticsEvent({
        eventName: analyticsEvents.commandExecuted,
        custom: {
            commandId: commandId,
            commandSource: source,
        },
    });
};
